import { defineStore } from 'pinia'
import { api, setAccessToken } from '@/utils/api'
import { useNavigationStore } from '@/store/NavigationStore.js'
import { useNotificationStore } from '@/store/NotificationStore.js'
import { useUserStore } from '@/store/UserStore.js'
import { useInstructionStore } from '@/store/InstructionStore.js'
import { useInvitationStore } from '@/store/InvitationStore.js'
import role from '@/utils/role'
import router from '@/router'
import Cookies from 'js-cookie'
import { chatSocket } from '@/utils/chatSocket'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        error: null,
        hasAdminToken: !!Cookies.get('admin_token')
    }),

    actions: {
        async login(login, password) {
            let data = {
                'login': login,
                'password': password
            };
            try {
                const response = await api.post('/login/auth', data);

                Cookies.set('access_token', response.data.token);
                if (response.data.refreshToken) {
                    Cookies.set('refresh_token', response.data.refreshToken);
                }
                console.log(response);
                await this.authUser(response.data.token);


            } catch (error) {
                console.log(error);
                if (error.response && error.response.data) {
                    console.log(error.response.data.message);
                    this.error = error.response.data.message;
                } else {
                    this.error = error.message || 'Ошибка авторизации';
                }
            }
        },

        async loginAsUser(userId) {
            try {
                const response = await api.get(`/admin/user-token?userId=${userId}`);

                const currentToken = Cookies.get('access_token');
                if (currentToken) {
                    Cookies.set('admin_token', currentToken);
                    this.hasAdminToken = true;
                }

                Cookies.set('access_token', response.data.token);
                if (response.data.refreshToken) {
                    Cookies.set('refresh_token', response.data.refreshToken);
                }
                console.log(response);
                await this.authUser(response.data.token);
            } catch (error) {
                console.log(error);
                if (error.response && error.response.data) {
                    console.log(error.response.data.message);
                    this.error = error.response.data.message;
                } else {
                    this.error = error.message || 'Ошибка авторизации';
                }
            }
        },

        async reloginAsAdmin() {
            const adminToken = Cookies.get('admin_token');
            if (adminToken) {
                Cookies.set('access_token', adminToken);
                Cookies.remove('admin_token');
                this.hasAdminToken = false;
                await this.authUser(adminToken);
                router.push('/admin/users');
            }
        },

        async logout() {
            chatSocket.disconnect()
            try {
                await api.post('/login/logout', { refreshToken: Cookies.get('refresh_token') })
                Cookies.remove('access_token');
                Cookies.remove('refresh_token');
                Cookies.remove('admin_token');
            } catch (e) {
                console.log(e)
            }
            this.hasAdminToken = false;
            useNotificationStore().clearBanners();
            router.push('/login');
        },

        async refreshToken() {
            try {
                const expiredToken = Cookies.get('access_token');
                const refreshToken = Cookies.get('refresh_token');
                const response = await api.post('/login/refresh',
                    { refreshToken: refreshToken },
                    {
                        headers: {
                            'Authorization': `Bearer ${expiredToken || ''}`
                        },
                        _isRefreshRequest: true,
                        skipErrorNotification: true
                    }
                );

                const newToken = response.data.token;
                Cookies.set('access_token', newToken);
                if (response.data.refreshToken) {
                    Cookies.set('refresh_token', response.data.refreshToken);
                }
                setAccessToken(newToken);

                return newToken;
            } catch (error) {
                console.log(error);

                if (error.response && error.response.data) {
                    console.log(error.response.data.message);
                    this.error = error.response.data.message;
                } else {
                    this.error = error.message || 'Ошибка обновления токена';
                }

                return null;
            }
        },

        async checkUserData(data) {
            console.log(data)
            try {
                const response = await api.post("/login/validate-data", data, { skipErrorNotification: true });

                console.log(response);
                return response
            } catch (error) {
                if (error.response && error.response.data) {
                    this.error = error.response.data.message || 'Ошибка валидации';
                } else {
                    this.error = 'Ошибка валидации';
                }
            }
        },

        async register(data) {
            const referralCode = localStorage.getItem('referral_code')
            data.referralCode = referralCode
            console.log(data)
            try {
                const response = await api.post('/login/registration', data);

                console.log(response.data);
                this.error = null;
                // this.login(data.email, data.password)
                localStorage.removeItem('referral_code')
            } catch (error) {
                if (error.response && error.response.data) {
                    this.error = error.response.data.message || 'Ошибка регистрации';
                } else {
                    this.error = 'Ошибка регистрации';
                }
            }
        },

        async sendVerificationCode(email) {
            try {
                const response = await api.post(`/login/mail/verify/send?email=${email}`);

                console.log(response.data);
                this.error = null;
            } catch (error) {
                if (error.response && error.response.data) {
                    this.error = error.response.data.message || 'Ошибка валидации';
                } else {
                    this.error = 'Ошибка валидации';
                }
            }
        },

        async verifyEmail(email, code) {
            try {
                const response = await api.post(`/login/mail/verify?email=${email}&code=${code}`);

                console.log(response.data);
                this.error = null;
            } catch (error) {
                if (error.response && error.response.data) {
                    this.error = error.response.data.message || 'Ошибка валидации';
                } else {
                    this.error = 'Ошибка валидации';
                }
            }
        },

        async authUser(token) {
            setAccessToken(token);
            chatSocket.connect();

            const inviteToken = localStorage.getItem('invite_token');
            if (inviteToken) {
                try {
                    await api.post(`/invites/${inviteToken}/join`, {}, { skipErrorNotification: true, skipSuccessNotification: true });
                } catch {
                    // 409 = уже участник, 410 = истекла — оба случая не критичны
                } finally {
                    localStorage.removeItem('invite_token');
                }
            }

            const userStore = useUserStore();
            await userStore.fetchMyUserInfo();

            const userRole = role.getMaxRole(userStore.myUserInfo?.roles)

            console.log(userRole)
            console.log(role.checkRole(userRole, "ROLE_WORKER"))

            if (userRole === 'ROLE_WORKER') {
                useNavigationStore().setActiveTab('work');
                router.push('/work');
            } else if (userRole === 'ROLE_ADMIN') {
                useNavigationStore().setActiveTab('usersAdmin');
                router.push('/admin/users');
            } else {
                useNavigationStore().setActiveTab('home');
                router.push('/home');
            }

            useNavigationStore().setNavBarVisible(true);
            useNavigationStore().setHeaderVisible(true);

            useInstructionStore().showIfNeeded();
            await useInvitationStore().showIfNeeded();
        }
    },


})
